module services {
    export module master {
        export class notifyPartyService implements interfaces.master.INotifyPartyService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all Terms Of Payment for a dropdown/autocomplete list
            getDropdownList(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "NotifyParty/GetDropdownList", {
                    ownerEntityId: '@ownerEntityId',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("notifyPartyService", services.master.notifyPartyService);
}